import type { TFunction } from 'i18next';

export type BulkTradeFileRecord = {
  type: string;
  requestType: string;
  url: string;
};

export type AllocationFileRecord = {
  requestType: string;
  url: string;
  type: string;
};

/** Labels download buttons for `bulkTradeFiles` entries (list + detail). */
export function getBulkTradeFileDownloadLabel(
  file: Pick<BulkTradeFileRecord, 'type'>,
  t: TFunction,
  sameTypeCount: number,
  totalSameType: number,
): string {
  const suffix = totalSameType > 1 ? `: ${sameTypeCount}` : '';
  if (file.type === 'SECURITIES') {
    return `${t('buySellTradeFile')}${suffix}`;
  }
  if (file.type === 'MUTUAL_FUND') {
    return `${t('mutualFundTradeFile')}${suffix}`;
  }
  return `${file.type}${suffix}`;
}

/** Labels download buttons for `allocationFiles` entries (list + detail). */
export function getAllocationFileDownloadLabel(
  file: Pick<AllocationFileRecord, 'type'>,
  t: TFunction,
  sameTypeCount: number,
  totalSameType: number,
): string {
  const suffix = totalSameType > 1 ? `: ${sameTypeCount}` : '';
  if (file.type === 'ALL') {
    return `${t('allocationFile')}${suffix}`;
  }
  return `${file.type} ${t('allocationFile')}${suffix}`;
}
